
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

var OvertimeApplyPage = Vue.extend({})
Vue.component('overtimeApply-page', OvertimeApplyPage)

export default {
name: 'OvertimeApplyPage',
directives: {
TransferDom
},
components: {
XTable,Group,Radio,PopupHeader,Popup,CellBox,Flexbox,FlexboxItem,XTextarea
},
props: {
saveStatus: Number
},
data () {
return {
baseUrl: this.$store.state.url,
flowId: '',
info: {},
typeLabel:'',
selectModelFlag: false, //下拉选择弹框控制
selectModelTitle: '加班类型', //下拉选择弹框标题
selectModelData:[], //下拉选择弹框数据
selectModel: '',
selectItem: '',
startDate: '',
endDate: '',
nowDate: '',
leaveDay: '',
dateDiffer: '',

overtimeReason: '',
remark: ''
}
},
mounted () {
this.axios({
url: this.baseUrl+'/wechat/overtime/modOvertime',
method: 'get'
}).then((response) => {
this.info = response.data.form;
}).catch((response) => {
this.$vux.loading.hide();
});
this.$emit('sendTitleToParent','加班申请');
},
methods: {
showMsg (msg) {
this.$vux.alert.show({
title: msg
})
setTimeout(() => {
this.$vux.alert.hide()
}, 2000)
},
openPopup () {
this.selectModelData = [];
this.getAllTypes();
this.selectModelFlag = true;
},
getAllTypes () {//获取加班类型
this.axios({
url: this.baseUrl+'/wechat/overtime/types',
method: 'get'
}).then((response) => {
response.data.list.forEach((item) => {
item.key = item.id;
item.value = item.name;
this.selectModelData.push(item);
})
}).catch((response) => {
this.$vux.loading.hide();
});
},
getType (value, label) {
this.selectItem = label;
let isChange = value == this.selectModel ? false : true
if(isChange){
this.selectModelFlag = false;
}
},
chooseStartDate () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD HH:mm',
minuteList: ['00', '15', '30', '45'],
endDate: this.endDate,
value: this.startDate,
onConfirm (val) {
that.startDate = val
that.getDateDiffer()
}
})
},
chooseEndDate () {
let that = this
this.$vux.datetime.show({
cancelText: '取消',
confirmText: '确定',
format: 'YYYY-MM-DD HH:mm',
value: this.endDate,
minuteList: ['00', '15', '30', '45'],
startDate: this.startDate,
onConfirm (val) {
that.endDate = val
that.getDateDiffer()
}
})
},
async getDateDiffer () {
if (this.startDate != '' && this.endDate != '') {
let res = await this.axios({
url: this.baseUrl + '/wechat/overtime/countOvertimeDays?startTime=' + this.startDate + '&endTime=' + this.endDate,
method: 'get'
});
if (res.data.status == 1) {
this.dateDiffer = res.data.overtimeDay + '天 ' + res.data.overtimehour + '小时  共计' + res.data.overtimeCountHour + '小时';
this.countOvertimeDays = res.data;
}
}
},

saveForm () { // 保存
if (this.selectItem == '' || this.startDate == '' || this.endDate == '' || this.overtimeReason == '') {
this.showMsg('请补充必填信息');
return false;
}
this.$vux.loading.show({
text: '加载中'
})
let formData = new FormData();
formData.append('id', this.info.id);
formData.append('overtimeTypeId', this.selectModel);
formData.append('startTime', this.startDate);
formData.append('endTime', this.endDate);
formData.append('overtimeDay', this.countOvertimeDays.overtimeDay);
formData.append('overtimeHour', this.countOvertimeDays.overtimehour);
formData.append('overtimeCountHour', this.countOvertimeDays.overtimeCountHour);
formData.append('overtimeReason', this.overtimeReason);
formData.append('remark', this.remark)

this.axios({
url: this.baseUrl + '/wechat/overtime',
method: 'post',
data: formData
}).then((response) => {
if (response.data.status == 0) { // 保存失败
console.log('保存失败')
this.$vux.loading.hide()
this.showMsg(response.data.msg)
} else if (this.saveStatus == 0 && response.data.status == 1) { // 父组件操作发起，并且保存成功
console.log('startFlow')
this.startFlow()
} else if (this.saveStatus == 1 && response.data.status == 1) { // 父组件操作提交，并且保存成功
console.log('$emit')
this.$emit('sendStatusToParent', {status: 1})
this.$vux.loading.hide()
}
}).catch((response) => {
this.$vux.loading.hide()
})
},
startFlow () { // 发起

let startData = new FormData();
startData.append('id', this.info.id);
startData.append('flowId', this.info.id);
this.axios({
url: this.baseUrl + '/wechat/overtime/startFlow',
method: 'post',
data: startData
}).then((response) => {
console.log('startFlow', response.data);
this.showMsg('保存成功！请继续完成提交操作！');

if (response.data.status == 1) {
this.$emit('sendStatusToParent', {
status: 0,
id: response.data.taskId,
stepId: response.data.stepId
})
}
this.$vux.loading.hide();
}).catch((response) => {
this.$vux.loading.hide();
})
}
}
}



// WEBPACK FOOTER //
// ./src/components/launch/attendance/overtimeApply.vue